import axios from "axios";

const instance = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // 这里可以修改为你的 API 地址
  baseURL: process.env.NODE_ENV === 'production' ? window.$configUrl.apiUrl : '/api',
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});
console.log("baseURL", instance.defaults.baseURL);

// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    // 在发送请求之前可以做一些处理，例如添加 token
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    // 这里可以处理响应数据，例如统一格式化返回的数据
    return response.data;
  },
  (error) => {
    // 处理错误
    console.error("请求错误:", error);
    return Promise.reject(error);
  }
);

const request = {
  get(url, params) {
    return instance.get(url, { params });
  },
  post(url, data) {
    console.log("baseURL", instance.defaults.baseURL);
    return instance.post(url, data);
  },
  put(url, data) {
    return instance.put(url, data);
  },
  delete(url, params) {
    return instance.delete(url, { params });
  },
};

export default request;
